import { Card, CardBody, Table } from "reactstrap";
import React from "react";

export default function MapDetails({
  singleCustomerPostcode,
  customTitle,
  bare,
}) {
  const singleCustomerPostcodeFiltered = singleCustomerPostcode?.replace(
    " ",
    "%20"
  );
  const iframe = `<iframe src="https://maps.google.com/maps?q=${singleCustomerPostcodeFiltered}&t=&z=14&ie=UTF8&iwloc=&output=embed" width="100%" height="300" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`;
  // const iframe = "";
  function Iframe(props) {
    return (
      <div
        className="iframe-container"
        dangerouslySetInnerHTML={{ __html: props.iframe }}
      />
    );
  }
  // Bare = just the map (caller wraps it, e.g. in an InfoCard on the Overview).
  if (bare) {
    return <Iframe iframe={iframe} />;
  }

  return (
    <>
      <Card>
        <CardBody className={"m-0 p-0"}>
          <h5
            className={
              customTitle ? "text-center card-title p-1" : "card-title p-1"
            }
          >
            {customTitle ?? "Map Details"}
          </h5>
          <div className="table-responsive">
            <Table className="table-borderless mb-0">
              <tbody>
                <tr>
                  <td>
                    <div>
                      <Iframe iframe={iframe} />
                    </div>
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </>
  );
}
